import React from "react";

const Error = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="stop" clipPath="url(#clip0_992_33646)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.46967 0.21967C4.61032 0.0790176 4.80109 0 5 0H11C11.1989 0 11.3897 0.0790176 11.5303 0.21967L15.7803 4.46967C15.921 4.61032 16 4.80109 16 5V11C16 11.1989 15.921 11.3897 15.7803 11.5303L11.5303 15.7803C11.3897 15.921 11.1989 16 11 16H5C4.80109 16 4.61032 15.921 4.46967 15.7803L0.21967 11.5303C0.0790176 11.3897 0 11.1989 0 11V5C0 4.80109 0.0790176 4.61032 0.21967 4.46967L4.46967 0.21967ZM5.31066 1.5L1.5 5.31066V10.6893L5.31066 14.5H10.6893L14.5 10.6893V5.31066L10.6893 1.5H5.31066ZM8 4C8.41421 4 8.75 4.33579 8.75 4.75V8.25C8.75 8.66421 8.41421 9 8 9C7.58579 9 7.25 8.66421 7.25 8.25V4.75C7.25 4.33579 7.58579 4 8 4ZM8 12C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z"
          fill="#CF222E"
        />
      </g>
      <defs>
        <clipPath id="clip0_992_33646">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Error;
